'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _button = require('@liveauctioneers/caterwaul-components/lib/button');

var _button2 = _interopRequireDefault(_button);

var _FormattedMessage = require('../../../components/Formatted/FormattedMessage');

var _FormattedMessage2 = _interopRequireDefault(_FormattedMessage);

var _link = require('@liveauctioneers/caterwaul-components/lib/link');

var _link2 = _interopRequireDefault(_link);

var _LoggedOut = require('./LoggedOut.scss');

var _LoggedOut2 = _interopRequireDefault(_LoggedOut);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoggedOut = function (_Component) {
    (0, _inherits3.default)(LoggedOut, _Component);

    function LoggedOut() {
        (0, _classCallCheck3.default)(this, LoggedOut);
        return (0, _possibleConstructorReturn3.default)(this, (LoggedOut.__proto__ || (0, _getPrototypeOf2.default)(LoggedOut)).apply(this, arguments));
    }

    (0, _createClass3.default)(LoggedOut, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                openCreateAccountModal = _props.openCreateAccountModal,
                openLoginModal = _props.openLoginModal;


            return (0, _jsx3.default)('div', {
                className: _LoggedOut2.default['logged-out-controls']
            }, void 0, (0, _jsx3.default)(_link2.default, {
                className: _LoggedOut2.default['link-default'],
                onClick: openLoginModal,
                primaryWeak: true
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'log_in'
            })), (0, _jsx3.default)(_button2.default, {
                primary: true,
                className: _LoggedOut2.default['button-default'],
                onClick: openCreateAccountModal
            }, void 0, (0, _jsx3.default)(_FormattedMessage2.default, {
                id: 'sign_up'
            })));
        }
    }]);
    return LoggedOut;
}(_react.Component);

exports.default = LoggedOut;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/Login/LoggedOut.js
// module id = 5Sl0
// module chunks = 60